import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Copy, Users, Rocket, Trophy } from "lucide-react";

export default function ReferralCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/me/referrals").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;

  const link = `${window.location.origin}/?ref=${data.ref_code}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Referral link copied — share it everywhere!");
    } catch {
      toast.error("Copy failed — long-press to copy manually");
    }
  };

  return (
    <div className="border border-[#3a3a3a] bg-[#121212] p-6 mt-8" data-testid="referral-card">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04]">
          // Your referral link
        </div>
        <Link
          to="/leaderboard"
          data-testid="referral-leaderboard-link"
          className="font-mono text-[11px] uppercase tracking-widest text-[#e2e2e2] hover:text-[#cfff04] inline-flex items-center gap-1.5 transition-colors"
        >
          <Trophy size={11} /> Leaderboard →
        </Link>
      </div>
      <p className="text-sm text-[#e2e2e2] mb-4">
        Anyone who signs up through your link counts toward your spot on the public leaderboard.
      </p>
      <div className="flex items-stretch gap-2 mb-5">
        <div
          className="flex-1 border border-[#3a3a3a] bg-[#050505] px-4 py-3 font-mono text-xs text-[#cfff04] truncate flex items-center"
          data-testid="referral-link"
        >
          {link}
        </div>
        <button
          onClick={copy}
          data-testid="referral-copy"
          className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-[11px] px-4 inline-flex items-center gap-1.5"
        >
          <Copy size={12} /> Copy
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="border border-[#3a3a3a] bg-[#050505] p-4" data-testid="referral-signups">
          <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-1">
            <Users size={11} /> Signups
          </div>
          <div className="font-display font-black text-3xl">{data.signups}</div>
        </div>
        <div className="border border-[#3a3a3a] bg-[#050505] p-4" data-testid="referral-paid">
          <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0] mb-1">
            <Rocket size={11} /> Paid launches
          </div>
          <div className="font-display font-black text-3xl text-[#00ff41]">{data.paid_launches}</div>
        </div>
      </div>
    </div>
  );
}
